// This icon file is generated automatically.
var BookmarkFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M19.78 22L12 16.44 4.22 22V4.22A2.22 2.22 0 016.44 2h11.11a2.22 2.22 0 012.23 2.22V22z" } }] }, "name": "bookmark", "theme": "filled" };
export default BookmarkFilled;
